import { client } from "utils";

export const requestLanguages = () => client.get("languages");
